<template>
  <div>
    <el-card>
      <el-button slot="header" size="medium" type="primary" @click="raturnList()">{{$t('lang.btn_returnUseristratorsList')}}</el-button>
      <el-table :data="tableData" class="wid100" :row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" v-if="this.postAuditListcheckbox"></el-table-column>
        <el-table-column
          type="index"
          :index="indexMethod" align="center"
          :label="$t('lang.lab_index')"
          width="55px"
        ></el-table-column>
      <el-table-column prop="id" :label="$t('lang.lab_id')"></el-table-column>
      <el-table-column prop="deptName" :label="$t('lang.lab_deptName')"></el-table-column>
      <el-table-column :label="$t('lang.lab_operation')">
        <template slot-scope="scope">
          <el-button class="orange" @click="delete1(scope.row.id, scope.row.pid)">{{deletename}}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageCount: 0,
      pageNum: 1,
      pageSize: 10,
      newId: '',
      tableData: [],
      multipleSelection: [], // 多选框
      postAuditListcheckbox: require('@/config/enum').postAuditListcheckbox, // 是否隐藏复选框
      deletename: require('@/config/enum').deletename
    }
  },
  created() {
    this.newId = this.$route.query.id
    this.listShow()
  },
  methods: {
    // ID序号功能
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 列表隔行变色
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 点击换页
    handleCurrentChange(val) {
      this.pageNum = val
      this.listShow()
    },
    // 点击更改每页容量
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.listShow()
    },
    listShow() {
      let loading = this.$loading()
      this.$get(`/getOrgDepartmentListByPid/${this.newId}?pageSize=${this.pageSize}&pageNo=${this.pageNum}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 返回部门列表
    raturnList() {
      this.$router.push({ name: 'useristratorsList' })
    },
    delete1(id) {
      let loading = this.$loading()
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$delete(`/delOrgDept/${id}/${this.newId}`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.listShow()
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      })
      .catch(() => {
        loading.close()
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
  }
}
</script>

<style scoped>

</style>